import PropTypes from 'prop-types';
var propTypes = {
  children: PropTypes.node.isRequired,
  direction: PropTypes.oneOf(['auto', 'ltr', 'rtl']),
  locale: PropTypes.string
};
export default propTypes;